import React, { ReactNode } from 'react';
import classes from './InputGroup.module.scss';



interface IProps {
  children: ReactNode;
}

const InputGroup:React.FC<IProps> = ({ children }) => {
  return (
    <div className={classes.Container}>
      {children}
    </div>
  )
}

export default InputGroup;
